<div class="wrapper w-100">
  <!-- Sidebar -->

  <nav id="sidebar" [ngClass]="status ? 'active' : ''">
    <button style="overflow: visible; z-index: 999;" class="close-button" type="button" id="sidebarCollapse" (click)="status=!status">
      @if (status) {
        <div style="overflow: visible;z-index: 999;"><i style="overflow: visible;z-index: 999;" class="fas fa-angle-right"></i></div>
      }

      @if (!status) {
        <div style="overflow: visible;z-index: 999;"><i style="overflow: visible;z-index: 999;" class="fas fa-angle-left"></i></div>
      }
    </button>
    <div class="sidebar-header">
      <h3>{{'NavMenu.Homeowners'|translate}}</h3>
    </div>

    <ul class="list-unstyled components">

      <li>
        <a routerLinkActive="active-tab" (click)="status=!status" routerLink="new-homeowners">{{'NavMenu.NewHomeowners'|translate}}</a>
      </li>
      <li>
        <a routerLinkActive="active-tab" (click)="status=!status" routerLink="realproperty">{{'NavMenu.RealPropAssessment'|translate}}</a>
      </li>
      <li>
        <a routerLinkActive="active-tab" (click)="status=!status" routerLink="property-search">{{'NavMenu.PropSearchTool'|translate}}</a>
      </li>
      <li>
        <a routerLinkActive="active-tab" (click)="status=!status" routerLink="proposition-19">{{'NavMenu.TransferringValue'|translate}}</a>
      </li>
      <li>
        <a routerLinkActive="active-tab" (click)="status=!status" routerLink="change-mailing-address">{{'NavMenu.ChangeMailingAdd'|translate}}</a>
      </li>
      <li>
        <a routerLinkActive="active-tab" (click)="status=!status" routerLink="change-in-ownership">{{'NavMenu.ChangeOwnership'|translate}}</a>
      </li>
      <li>
        <a routerLinkActive="active-tab" (click)="status=!status" routerLink="death-of-an-owner">{{'NavMenu.DeathofOwner'|translate}}</a>
      </li>
      <li>
        <a routerLinkActive="active-tab" (click)="status=!status" routerLink="new-construction">{{'NavMenu.NewConst'|translate}}</a>
      </li>
      <li>
        <a routerLinkActive="active-tab" (click)="status=!status" routerLink="adu">{{'NavMenu.ADUv2'|translate}}</a>
      </li>
      <li>
        <a routerLinkActive="active-tab" (click)="status=!status" routerLink="homeowner-exemption">{{'NavMenu.HomeExv2'|translate}}</a>
      </li>
      <li>
        <a routerLinkActive="active-tab" (click)="status=!status" routerLink="contest-assessment">{{'NavMenu.ContestValue'|translate}}</a>
      </li>
      <!-- <li>
      <a routerLinkActive="active-tab" (click)="status=!status" routerLink="supplemental-tax-estimator">{{'NavMenu.SupplementalEstimator'|translate}}</a>
    </li> -->



  </ul>

</nav>
<div id="content">

  <!-- <button type="button" id="sidebarCollapse" (click)="status=!status" class="btn btn-info">
  <i class="fas fa-align-left"></i>
  <span>Toggle Sidebar</span>
</button> -->
<router-outlet></router-outlet>
</div>


</div>
